








































import {CbcMixin} from "@/modules/cbc/mixins";
import {AdditionalInfo, AdditionalInfoCreateRequest, SummaryTypeEnum} from "@/modules/cbc/models";
import CompanyDisplayComponent from "@/modules/country/components/CompanyDisplay.vue";
import {CountryMixin} from "@/modules/country/mixins";
import {LanguageMixin} from "@/modules/language/mixins";
import {Component, Emit, Mixins, Prop} from "vue-property-decorator";

@Component({
	components: {
		CompanyDisplayComponent
	}
})
export default class AdditionalInfoListComponent extends Mixins(CbcMixin, CountryMixin, LanguageMixin) {

	@Prop({default: () => []})
	public readonly additionalInfo!: AdditionalInfo[];

	public expanded: any[] = [];

	public headers: any[] = [
		{
			text: "jurisdictions",
			value: "jurisdictions",
			align: "start"
		},
		{
			text: "Summary Types",
			value: "summaryTypes",
			align: "start"
		}
	];
	public headersExpand: any[] = [
		{
			text: "Information",
			value: "info",
			align: "start"
		},
		{
			text: "Language",
			value: "language",
			align: "start"
		}
	];

	@Emit("create")
	public onCreate() {
		return {
			reportId: this.$route.params["reportId"],
			additionalInfo: {}
		} as AdditionalInfoCreateRequest
	}

	@Emit("get-additional-info")
	public onClickRow(row: AdditionalInfo) {
		return row;
	}

	public getSummaryTypeNames(ids: SummaryTypeEnum[]): string {
		if (ids && ids.length > 0)
			return this.summaryTypes.filter(x => ids.find(y => x.id === y))!.map(x => x.name)!.join(", ");
		else return "";
	}
}
